import { Directive, HostBinding } from '@angular/core';


export const PASSWORD_MANAGER_IGNORE_ATTRIBUTES = {
  bitwarden: { name: 'data-bwignore', value: '' },
  /** LastPass requires the string value `"true"`, not just presence. */
  lastPass: { name: 'data-lpignore', value: 'true' },
  /** 1Password. Presence of the attribute is enough. */
  onePassword: { name: 'data-1p-ignore', value: '' },
  /** Dashlane. Requires the value `"other"` to skip the field. */
  dashlane: { name: 'data-form-type', value: 'other' },
} as const;

/**
 * Opt-in attribute directive that marks an `<input>` as off-limits for
 * third-party password manager overlays (Bitwarden, LastPass, 1Password,
 * Dashlane).
 *
 * @example
 * ```html
 * <input type="email" formControlName="email" appIgnorePasswordManagers />
 * ```
 */
@Directive({
  selector: '[appIgnorePasswordManagers]',
  standalone: true,
})
export class IgnorePasswordManagersDirective {
  @HostBinding(`attr.${PASSWORD_MANAGER_IGNORE_ATTRIBUTES.bitwarden.name}`)
  readonly bwIgnore = PASSWORD_MANAGER_IGNORE_ATTRIBUTES.bitwarden.value;

  @HostBinding(`attr.${PASSWORD_MANAGER_IGNORE_ATTRIBUTES.lastPass.name}`)
  readonly lpIgnore = PASSWORD_MANAGER_IGNORE_ATTRIBUTES.lastPass.value;

  @HostBinding(`attr.${PASSWORD_MANAGER_IGNORE_ATTRIBUTES.onePassword.name}`)
  readonly onePasswordIgnore = PASSWORD_MANAGER_IGNORE_ATTRIBUTES.onePassword.value;

  @HostBinding(`attr.${PASSWORD_MANAGER_IGNORE_ATTRIBUTES.dashlane.name}`)
  readonly dashlaneIgnore = PASSWORD_MANAGER_IGNORE_ATTRIBUTES.dashlane.value;
}
